// import React, { lazy, Suspense } from 'react';
// import { useSelector } from 'react-redux';
// import { Route, Routes, useNavigate } from 'react-router-dom';


// //? import service routes
// //const PageNotFound = lazy(() => import('../shared/pages/PageNotFound'));
// const DocumentManagement = lazy(() => import('../Details/DocumentManagement'));
// // const Register = lazy(() => import('../domain/auth/pages/Register'));
// // const EBookRoutes = lazy(() => import('../domain/ebook/routers/EBookRoutes'));
// // const Spinner = lazy(() => import('../shared/components/popup/Spinner'));
// // const ForgotPassword = lazy(() => import('../domain/auth/pages/ForgotPassword'));
// // const ResetPassword = lazy(() => import('../domain/auth/pages/ResetPassword'));

// export default function Routers() {
//     return (
//         // <Suspense fallback={<Spinner />}>
//         <Suspense>
//             <Routes>
                
//                 {/* //? Library management service  */}
//                         {/* <Route path="/*" element={<EBookRoutes />} /> */}
//                 {/* //? Auth management service  */}
                
//                 <Route path="documentmanagement" element={<DocumentManagement />} />
//                 {/* <Route path="forgot-password" element={<ForgotPassword />} />
//                 <Route path="reset-password/:token" element={<ResetPassword />} /> */}
//                 {/* <Route path="register" element={<Register />} /> */}

//                 {/* //? 404 not found route  */}
//                 {/* <Route path="*" element={<PageNotFound />} /> */}
//             </Routes>
//         </Suspense>
//     );
// }

import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const DocumentManagement = lazy(() => import('../components/DocumentManagement'));

export default function Routers() {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Routes>
                {/* Define the full path */}
                <Route path="/documentmanagement" element={<DocumentManagement />} />
            </Routes>
        </Suspense>
    );
}
